export const openXlsx = (
  file: string,
  fileName: string,
  fileType: string,
  cb?: () => void
) => {
  const linkSource = `data:${fileType};base64,${file}`
  const link = document.createElement('a')
  link.href = linkSource
  link.download = `${fileName}.xlsx`
  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }, 0)

  if (cb) {
    cb()
  }
}
